import { track } from './analytics-tracker';

class PublicAnalytics {
  // Finmo Choose Account events
  finmoChooseAccount = {
    /** @param {String} provider */
    continueWithButtonClick: (provider: string) => trackFinmoChooseAccount('continue_click', { provider }),
  };

  // Landing page events
  landing = {
    existingUserButtonClick: () => trackLanding('existing_user_button_click'),

    spotlightWebsiteLinkClick: () => trackLanding('spotlight_website_link_click'),

    newUserButtonClick: () => trackLanding('new_user_button_click'),
  };

  // Login page events
  login = {
    /** @param {String} provider */
    continueWithButtonClick: (provider: string) => trackLogin('continue_with_button_click', { provider }),

    continueWithEmailClick: () => trackLogin('continue_with_email_click'),

    forgotPasswordClick: () => trackLogin('forgot_password_click'),

    getFinmoProButtonClick: () => trackLogin('get_finmo_pro_button_click'),

    learnMoreButtonClick: () => trackLogin('learn_more_button_click'),

    resetPasswordClick: () => trackLogin('reset_password_click'),

    sendResetLinkClick: () => trackLogin('send_reset_link_click'),

    signUpLinkClick: () => trackLogin('sign_up_link_click'),
  };

  // Signup page events
  signup = {
    getFinmoProButtonClick: () => trackSignup('get_finmo_pro_button_click'),

    learnMoreButtonClick: () => trackSignup('learn_more_button_click'),

    loginLinkClick: () => trackSignup('login_link_click'),

    resendVerificationEmailClick: () => trackSignup('resend_verification_email_click'),

    /** @param {String} provider */
    signUpWithButtonClick: (provider: string) => trackSignup('sign_up_with_button_click', { provider }),

    signUpWithEmailClick: () => trackSignup('sign_up_with_email_click'),
  };
}

/* Wrapper functions for setting area/event categories */
const trackLanding = track('landing');
const trackLogin = track('login');
const trackSignup = track('signup');
const trackFinmoChooseAccount = track('finmo_choose_account');

export default new PublicAnalytics();
